import { formatDateToKST } from '@/utils/parser';

export const getStatisticsCalendarSelectedDate = (date: Date) => {
  return formatDateToKST(date);
};
